/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';

// eslint-disable-next-line no-restricted-imports
import { ScreenBreakpoints } from 'components/responsive';
import React from 'react';
import Media from 'react-media';
// eslint-disable-next-line no-restricted-imports
import { escapeReturnUrl } from 'util/url';
import DesktopPlaceholder from './desktop-placeholder';
import HeaderLink from './header-link';
import HeaderLogo from './header-logo';
import styles from './header.less';

const formatPromo = forTemplate('header_promo_nav');
const formatSignUpLogin = forTemplate('header_signup_login');

const AnonymousHeader = () => {
  const returnUrl = escapeReturnUrl(location.href);

  return (
    <div
      className={classNames(styles.default, styles.header)}
      data-test-id={HeaderTestIds.Container}
    >
      <Media query={ScreenBreakpoints.MediumMin}>
        {(matches: boolean) =>
          matches && (
            <div className={styles.leftSection}>
              <HeaderLink href="/" preventDefault={false}>
                {formatPromo('home')}
              </HeaderLink>
              <HeaderLink href="/tour" preventDefault={false}>
                {formatPromo('tour')}
              </HeaderLink>
              <HeaderLink href="https://blog.trello.com" preventDefault={false}>
                {formatPromo('blog')}
              </HeaderLink>
            </div>
          )
        }
      </Media>
      <HeaderLogo preventDefault={false} />
      <div className={styles.rightSection}>
        <HeaderLink
          href={`/signup?returnUrl=${returnUrl}`}
          buttonStyle={'signUpColor'}
          preventDefault={false}
        >
          {formatSignUpLogin('sign-up')}
        </HeaderLink>
        <HeaderLink
          href={`/login?returnUrl=${returnUrl}`}
          buttonStyle={'normalColor'}
          preventDefault={false}
        >
          {formatSignUpLogin('log-in')}
        </HeaderLink>
        <DesktopPlaceholder />
      </div>
    </div>
  );
};

export default AnonymousHeader;



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/anonymous-header.tsx